import { Card, Table } from "antd";
import "./index.scss";
import { useGet } from "../../../hooks/useGet";
import BSC from "../../../assets/BSC.svg";
import CELO from "../../../assets/CELO.svg";
import ETH from "../../../assets/ETH.svg";
import MATIC from "../../../assets/MATIC.svg";
import ONE from "../../../assets/ONE.svg";
import { Paragraph } from "../../../components";
export var PriceOverview = function PriceOverview() {
  var chains = {
    BSC: BSC,
    CELO: CELO,
    ETH: ETH,
    MATIC: MATIC,
    ONE: ONE
  };
  var columns = [{
    dataIndex: "chain",
    key: "chain",
    render: function render(chain) {
      var _data$estimates$find;

      var label = (_data$estimates$find = data.estimates.find(function (estimate) {
        return estimate.chain === chain;
      })) === null || _data$estimates$find === void 0 ? void 0 : _data$estimates$find.label;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        src: chains[chain],
        className: "chainImage"
      }), " ", /*#__PURE__*/React.createElement("span", {
        className: "table-column"
      }, label));
    }
  }, {
    title: "Starter",
    dataIndex: "starter",
    key: "starter",
    align: "center"
  }, {
    title: "Basic",
    dataIndex: "basic",
    key: "basic",
    align: "center"
  }, {
    title: "Advanced",
    dataIndex: "advanced",
    key: "advanced",
    align: "center"
  }];

  var _useGet = useGet("/estimate"),
      data = _useGet.data;

  return /*#__PURE__*/React.createElement(Card, {
    title: "What plan do I need?"
  }, /*#__PURE__*/React.createElement(Paragraph, null, "Your monthly plan is used to pay for the gas fees necessary to mint NFTs. Some blockchains have higher gas fees, some have lower, so the number of NFTs you can mint per month will depend on the blockchain you are minting on. Check at the table below and see how many NFTs you can potentially mint, considering the current blockchain transaction fees."), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    dataSource: data === null || data === void 0 ? void 0 : data.estimates,
    pagination: false,
    loading: !data,
    rowKey: "key"
  }));
};